import React from 'react';
import { AttentionBoxVariant, AvAttentionBox } from '@fabric-ui/components';
import { SxProps } from '@mui/material';

export const HistoricalFilterModeWarning = ({ sx }: { sx?: SxProps }) => (
  <AvAttentionBox variant={AttentionBoxVariant.Neutral} content="Only dimension filters are supported with Historical State." sx={sx} />
);
